import { useCallback } from "react";
import { useWeb3React } from "@web3-react/core";
import useWeb3 from "../useWeb3";
import { getClaimContract } from "../../utils/contractHelpers";
import {
  bundlers,
  CLAIMING_ADDRESS,
  CRASH_GAME_CONTRACT,
  LUCKIFY_CONTRACT_ADDRESS,
  USDT_CONTRACT_ADDRESS,
} from "../../utils/Enviroment";
import CrashGameABI from "../../utils/CrashGameAbi.json";

import { generatePrivateKey, privateKeyToAccount } from "viem/accounts";
import {
  createWalletClient,
  custom,
  decodeEventLog,
  encodeFunctionData,
  http as viemHttp,
} from "viem";
import {
  createBicoBundlerClient,
  smartSessionActions,
  toNexusAccount,
} from "@biconomy/abstractjs";
import { bsc } from "viem/chains";
import BalanceOfAbi from "../../../src/utils/UsdtABI.json";
import { useRecoilValue } from "recoil";
import { userSmartAccount } from "../../components/recoilAtom";
import getNodeUrl from "../../utils/getRpcUrl";
import { ethers, Log, toBigInt } from "ethers";
import LuckifyABI from "../../utils/LuckifyABI.json";
import {
  createSmartWalletClient,
  signPreparedCalls,
} from "@account-kit/wallet-client";
import ClaimAbi from "../../utils/ClaimABI.json";
import { LocalAccountSigner } from "@aa-sdk/core";
import { alchemy, defineAlchemyChain } from "@account-kit/infra";
import { useSessionPermissions } from "../checkSessionPermissions";
import axios from "axios";

export const CashOut = () => {
  const sendGasFeeAsUsdt = (usdtForGas) => {
    const usdtForGasinMwei = ethers.parseUnits(usdtForGas?.toFixed(6), 6);

    const encodedTransferCall = encodeFunctionData({
      abi: BalanceOfAbi,
      functionName: "transfer",
      args: ["0x9f0d847F45e06baeb9e11848040b76E1622406c6", usdtForGasinMwei],
    });
    return encodedTransferCall;
  };

  const ethToDollarConversion = async (dataa) => {
    let balace = await axios.get(
      "https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD"
    );
    let price = balace.data.USD;
    let ethBalance = dataa * price;
    return ethBalance;
  };

  const handleGasFeeWithPreparedCalls = async (
    smartAccountClient,
    smartAccount,
    callArgs
  ) => {
    console.log(smartAccountClient, smartAccount, callArgs, "preparedCalls");
    const preparedCalls = await smartAccountClient.prepareCalls({
      calls: callArgs,
      from: smartAccount,
    });
    console.log(preparedCalls, "preparedCalls");

    const { data } = preparedCalls;
    const callGasLimit = Number(data.callGasLimit);
    const verificationGasLimit = Number(data.verificationGasLimit);
    const preVerificationGas = Number(data.preVerificationGas);
    const maxFeePerGas = Number(data.maxFeePerGas);
    const totalGasLimit =
      callGasLimit + verificationGasLimit + preVerificationGas;
    const totalCostWei = totalGasLimit * maxFeePerGas;
    const totalCostEth = totalCostWei / 1e18;
    const gasFeeInDollars = await ethToDollarConversion(totalCostEth);
    const bufferedGasFee = (gasFeeInDollars * 120) / 100;
    return bufferedGasFee;
  };
  const RPC_URL = getNodeUrl();
  const web3 = useWeb3();
  const smartAccount = useRecoilValue(userSmartAccount);

  const { account } = useWeb3React();
  let chain = bsc;
  let placeBet = localStorage?.getItem("placeBet");
  let privateKey = localStorage?.getItem("privateKey");
  let nexusAccount = localStorage?.getItem("nexusAccount");
  let cashOutBool = localStorage?.getItem("cashOutBool");
  privateKey = JSON.parse(privateKey);
  nexusAccount = JSON.parse(nexusAccount);
  const permision1 = localStorage.getItem("signForAll");
  const permision = JSON.parse(permision1);
  const { grantPermissions } = useSessionPermissions();

  const CashoutHook = useCallback(
    async (
      date,
      smartAccountt,
      currentIndex,
      smartAccountClient,
      publicClient,
      permissions,
      sessionKey
    ) => {
      console.log(
        date.time,
        date.signedKey,
        currentIndex,
        "date.time, date.signedKe"
      );
      // const { userPermissions: permissions, userSessionKey: sessionKey } = await grantPermissions()
      const callArgsbefore = [
        {
          to: CRASH_GAME_CONTRACT, // The target contract address
          data: encodeFunctionData({
            abi: CrashGameABI,
            functionName: "cashout",
            args: [currentIndex, date.time, date.signedKey], // Pass the contract parameters
          }),
        },
      ];

      let gasFee = await handleGasFeeWithPreparedCalls(
        smartAccountClient,
        smartAccountt,
        callArgsbefore
      );
      const callArgs = [
        {
          to: CRASH_GAME_CONTRACT, // The target contract address
          data: encodeFunctionData({
            abi: CrashGameABI,
            functionName: "cashout",
            args: [currentIndex, date.time, date.signedKey], // Pass the contract parameters
          }),
        },
        {
          to: USDT_CONTRACT_ADDRESS,
          data: sendGasFeeAsUsdt(gasFee),
        },
      ];
      try {
        const preparedCalls = await smartAccountClient.prepareCalls({
          calls: callArgs,
          from: smartAccountt,
          capabilities: {
            permissions,
          },
        });
        const signedCalls = await signPreparedCalls(sessionKey, preparedCalls);
        const sendResult = await smartAccountClient.sendPreparedCalls({
          ...signedCalls,
          capabilities: {
            permissions,
          },
        });
        await new Promise((resolve) => setTimeout(resolve, 1000));
        const { preparedCallIds } = sendResult;
        await new Promise((resolve) => setTimeout(resolve, 3000));
        const status = await smartAccountClient.getCallsStatus(
          preparedCallIds[0]
        );

        const possibleTxHashes = [
          status.transactionHash,
          status.txHash,
          status.hash,
          status.receipt?.transactionHash,
          status.receipts?.[0]?.transactionHash,
          status.userOperationReceipt?.transactionHash,
          status.result?.transactionHash,
          status.data?.transactionHash,
        ];
        const txHash = possibleTxHashes.find((hash) => hash);

        const receipt = await publicClient.getTransactionReceipt({
          hash: txHash,
        });
        await new Promise((resolve) => setTimeout(resolve, 4000));

        console.log("Call status:", status);
        return receipt;

        //old code

        // const { preparedCallIds } = await smartAccountClient.sendPreparedCalls({
        //   ...signedCalls,
        //   capabilities: {
        //     permissions,
        //   },
        // });
        // const status = await smartAccountClient.getCallsStatus(
        //   preparedCallIds[0]
        // );
        // return status;
      } catch (e) {
        throw e;
      }
    },
    [web3, account]
  );

  const PlaceBeteHook = useCallback(
    async (
      api,
      amount,
      currentIndex,
      approveAmount,
      smartAccountt,
      smartAccountClient,
      permissions,
      sessionKey
    ) => {
      let convertedAmount = web3.utils.toWei(
        parseFloat(amount).toFixed(6).toString(),
        "mwei"
      );
      console.log(
        convertedAmount,
        currentIndex,
        api.rng,
        api.hash,
        "convertedAmount, currentIndex, api.rng, api.rng.hash"
      );
      currentIndex = currentIndex?.toString();
      // const { userPermissions: permissions, userSessionKey: sessionKey } = await grantPermissions()

      const callArgsbefore = approveAmount
        ? [
            {
              to: USDT_CONTRACT_ADDRESS, // Target contract address
              data: encodeFunctionData({
                abi: BalanceOfAbi,
                functionName: "approve",
                args: [
                  CRASH_GAME_CONTRACT,
                  10000000000000000000000000000000000000000n,
                ], // Approve a large amount for the create pool contract
              }),
            },
            {
              to: CRASH_GAME_CONTRACT, // The target contract address
              data: encodeFunctionData({
                abi: CrashGameABI,
                functionName: "placeCrashBet",
                args: [
                  convertedAmount,
                  currentIndex,
                  api?.rng,
                  api?.ciphertext,
                ], // Pass the contract parameters
              }),
            },
          ]
        : [
            {
              to: CRASH_GAME_CONTRACT, // The target contract address
              data: encodeFunctionData({
                abi: CrashGameABI,
                functionName: "placeCrashBet",
                args: [
                  convertedAmount,
                  currentIndex,
                  api?.rng,
                  api?.ciphertext,
                ], // Pass the contract parameters
              }),
            },
          ];

      let gasFee = await handleGasFeeWithPreparedCalls(
        smartAccountClient,
        smartAccountt,
        callArgsbefore
      );
      const callArgs = approveAmount
        ? [
            {
              to: USDT_CONTRACT_ADDRESS, // Target contract address
              data: encodeFunctionData({
                abi: BalanceOfAbi,
                functionName: "approve",
                args: [
                  CRASH_GAME_CONTRACT,
                  10000000000000000000000000000000000000000n,
                ], // Approve a large amount for the create pool contract
              }),
            },
            {
              to: CRASH_GAME_CONTRACT, // The target contract address
              data: encodeFunctionData({
                abi: CrashGameABI,
                functionName: "placeCrashBet",
                args: [
                  convertedAmount,
                  currentIndex,
                  api?.rng,
                  api?.ciphertext,
                ], // Pass the contract parameters
              }),
            },
            {
              to: USDT_CONTRACT_ADDRESS,
              data: sendGasFeeAsUsdt(gasFee),
            },
          ]
        : [
            {
              to: CRASH_GAME_CONTRACT, // The target contract address
              data: encodeFunctionData({
                abi: CrashGameABI,
                functionName: "placeCrashBet",
                args: [
                  convertedAmount,
                  currentIndex,
                  api?.rng,
                  api?.ciphertext,
                ], // Pass the contract parameters
              }),
            },
            {
              to: USDT_CONTRACT_ADDRESS,
              data: sendGasFeeAsUsdt(gasFee),
            },
          ];

      try {
        const preparedCalls = await smartAccountClient.prepareCalls({
          calls: callArgs,
          from: smartAccountt,
          capabilities: {
            permissions,
          },
        });
        const signedCalls = await signPreparedCalls(sessionKey, preparedCalls);
        const { preparedCallIds } = await smartAccountClient.sendPreparedCalls({
          ...signedCalls,
          capabilities: {
            permissions,
          },
        });
        const status = await smartAccountClient.getCallsStatus(
          preparedCallIds[0]
        );
        console.log("Call status:", status);

        return status;
      } catch (e) {
        throw e;
      }
    },
    [web3, account]
  );

  const WithDrawHook = useCallback(
    async (
      amount,
      approveAmount,
      smartAccountt,
      smartAccountClient,
      permissions,
      sessionkey
    ) => {
      let convertedAmount = web3.utils.toWei(amount?.toString(), "mwei");
      const callArgsbefore = approveAmount
        ? [
            {
              to: USDT_CONTRACT_ADDRESS, // Target contract address
              data: encodeFunctionData({
                abi: BalanceOfAbi,
                functionName: "approve",
                args: [
                  CRASH_GAME_CONTRACT,
                  10000000000000000000000000000000000000000n,
                ], // Approve a large amount for the create pool contract
              }),
            },
            {
              to: CRASH_GAME_CONTRACT, // The target contract address
              data: encodeFunctionData({
                abi: CrashGameABI,
                functionName: "withdraw",
                args: [convertedAmount], // Pass the contract parameters
              }),
            },
          ]
        : [
            {
              to: CRASH_GAME_CONTRACT, // The target contract address
              data: encodeFunctionData({
                abi: CrashGameABI,
                functionName: "withdraw",
                args: [convertedAmount], // Pass the contract parameters
              }),
            },
          ];
      let gasFee = await handleGasFeeWithPreparedCalls(
        smartAccountClient,
        smartAccountt,
        callArgsbefore
      );
      const callArgs = approveAmount
        ? [
            {
              to: USDT_CONTRACT_ADDRESS, // Target contract address
              data: encodeFunctionData({
                abi: BalanceOfAbi,
                functionName: "approve",
                args: [
                  CRASH_GAME_CONTRACT,
                  10000000000000000000000000000000000000000n,
                ], // Approve a large amount for the create pool contract
              }),
            },
            {
              to: CRASH_GAME_CONTRACT, // The target contract address
              data: encodeFunctionData({
                abi: CrashGameABI,
                functionName: "withdraw",
                args: [convertedAmount], // Pass the contract parameters
              }),
            },
            {
              to: USDT_CONTRACT_ADDRESS,
              data: sendGasFeeAsUsdt(gasFee),
            },
          ]
        : [
            {
              to: CRASH_GAME_CONTRACT, // The target contract address
              data: encodeFunctionData({
                abi: CrashGameABI,
                functionName: "withdraw",
                args: [convertedAmount], // Pass the contract parameters
              }),
            },
            {
              to: USDT_CONTRACT_ADDRESS,
              data: sendGasFeeAsUsdt(gasFee),
            },
          ];

      try {
        const preparedCalls = await smartAccountClient.prepareCalls({
          calls: callArgs,
          from: smartAccountt,
          capabilities: {
            permissions,
          },
        });
        const signedCalls = await signPreparedCalls(sessionkey, preparedCalls);
        const { preparedCallIds } = await smartAccountClient.sendPreparedCalls({
          ...signedCalls,
          capabilities: {
            permissions,
          },
        });
        const status = await smartAccountClient.getCallsStatus(
          preparedCallIds[0]
        );
        console.log("Call status:", status);
        return status;
      } catch (e) {
        throw e;
      }
    },
    [web3, account]
  );
  const AddLiqudityHood = useCallback(
    async (
      amount,
      approveAmount,
      smartAccountt,
      smartAccountClient,
      permissions,
      sessionkey
    ) => {
      let convertedAmount = web3.utils.toWei(amount?.toString(), "mwei");

      const callArgsbefore = approveAmount
        ? [
            {
              to: USDT_CONTRACT_ADDRESS, // Target contract address
              data: encodeFunctionData({
                abi: BalanceOfAbi,
                functionName: "approve",
                args: [
                  CRASH_GAME_CONTRACT,
                  10000000000000000000000000000000000000000n,
                ], // Approve a large amount for the create pool contract
              }),
            },
            {
              to: CRASH_GAME_CONTRACT, // The target contract address
              data: encodeFunctionData({
                abi: CrashGameABI,
                functionName: "deposit",
                args: [convertedAmount], // Pass the contract parameters
              }),
            },
          ]
        : [
            {
              to: CRASH_GAME_CONTRACT, // The target contract address
              data: encodeFunctionData({
                abi: CrashGameABI,
                functionName: "deposit",
                args: [convertedAmount], // Pass the contract parameters
              }),
            },
          ];
      let gasFee = await handleGasFeeWithPreparedCalls(
        smartAccountClient,
        smartAccountt,
        callArgsbefore
      );

      const callArgs = approveAmount
        ? [
            {
              to: USDT_CONTRACT_ADDRESS, // Target contract address
              data: encodeFunctionData({
                abi: BalanceOfAbi,
                functionName: "approve",
                args: [
                  CRASH_GAME_CONTRACT,
                  10000000000000000000000000000000000000000n,
                ], // Approve a large amount for the create pool contract
              }),
            },
            {
              to: CRASH_GAME_CONTRACT, // The target contract address
              data: encodeFunctionData({
                abi: CrashGameABI,
                functionName: "deposit",
                args: [convertedAmount], // Pass the contract parameters
              }),
            },
            {
              to: USDT_CONTRACT_ADDRESS,
              data: sendGasFeeAsUsdt(gasFee),
            },
          ]
        : [
            {
              to: CRASH_GAME_CONTRACT, // The target contract address
              data: encodeFunctionData({
                abi: CrashGameABI,
                functionName: "deposit",
                args: [convertedAmount], // Pass the contract parameters
              }),
            },
            {
              to: USDT_CONTRACT_ADDRESS,
              data: sendGasFeeAsUsdt(gasFee),
            },
          ];

      try {
        const preparedCalls = await smartAccountClient.prepareCalls({
          calls: callArgs,
          from: smartAccountt,
          capabilities: {
            permissions,
          },
        });
        const signedCalls = await signPreparedCalls(sessionkey, preparedCalls);
        const { preparedCallIds } = await smartAccountClient.sendPreparedCalls({
          ...signedCalls,
          capabilities: {
            permissions,
          },
        });
        const status = await smartAccountClient.getCallsStatus(
          preparedCallIds[0]
        );
        console.log("Call status:", status);
        return status;
      } catch (e) {
        throw e;
      }
    },
    [web3, account]
  );

  const PlaceBetLuckHook = useCallback(
    async (
      amount,
      odds,
      approveAmount,
      smartAccountt,
      smartAccountClient,
      permissions,
      sessionkey
    ) => {
      let amountConvert = web3.utils.toWei(amount?.toString(), "mwei");
      let oddsfinal = odds?.toString();
      console.log(
        amountConvert,
        oddsfinal,
        approveAmount,
        smartAccountt,
        smartAccountClient,
        permissions,
        sessionkey,
        "amount, odds, approveAmount, smartAccountt, clientt"
      );
      const callArgsbefore = approveAmount
        ? [
            {
              to: USDT_CONTRACT_ADDRESS,
              data: encodeFunctionData({
                abi: BalanceOfAbi,
                functionName: "approve",
                args: [
                  LUCKIFY_CONTRACT_ADDRESS,
                  100000000000000000000000000000000n,
                ],
              }),
            },
            {
              to: CRASH_GAME_CONTRACT, // The target contract address
              data: encodeFunctionData({
                abi: CrashGameABI,
                functionName: "placeBet",
                args: [amountConvert, oddsfinal], // Pass the contract parameters
              }),
            },
          ]
        : [
            {
              to: LUCKIFY_CONTRACT_ADDRESS, // The target contract address
              data: encodeFunctionData({
                abi: CrashGameABI,
                functionName: "placeBet",
                args: [amountConvert, oddsfinal], // Pass the contract parameters
              }),
            },
          ];

      let gasFee = await handleGasFeeWithPreparedCalls(
        smartAccountClient,
        smartAccountt,
        callArgsbefore
      );
      const callArgs = approveAmount
        ? [
            {
              to: USDT_CONTRACT_ADDRESS,
              data: encodeFunctionData({
                abi: BalanceOfAbi,
                functionName: "approve",
                args: [
                  LUCKIFY_CONTRACT_ADDRESS,
                  100000000000000000000000000000000n,
                ],
              }),
            },
            {
              to: CRASH_GAME_CONTRACT, // The target contract address
              data: encodeFunctionData({
                abi: CrashGameABI,
                functionName: "placeBet",
                args: [amountConvert, oddsfinal], // Pass the contract parameters
              }),
            },
            {
              to: USDT_CONTRACT_ADDRESS,
              data: sendGasFeeAsUsdt(gasFee),
            },
          ]
        : [
            {
              to: LUCKIFY_CONTRACT_ADDRESS, // The target contract address
              data: encodeFunctionData({
                abi: CrashGameABI,
                functionName: "placeBet",
                args: [amountConvert, oddsfinal], // Pass the contract parameters
              }),
            },
            {
              to: USDT_CONTRACT_ADDRESS,
              data: sendGasFeeAsUsdt(gasFee),
            },
          ];
      try {
        const preparedCalls = await smartAccountClient.prepareCalls({
          calls: callArgs,
          from: smartAccountt,
          capabilities: {
            permissions,
          },
        });
        const signedCalls = await signPreparedCalls(sessionkey, preparedCalls);
        const { preparedCallIds } = await smartAccountClient.sendPreparedCalls({
          ...signedCalls,
          capabilities: {
            permissions,
          },
        });
        const status = await smartAccountClient.getCallsStatus(
          preparedCallIds[0]
        );
        console.log("Call status:", status);
        return status;
      } catch (error) {
        console.log(error);
        throw error;
      }
    },
    [web3, account]
  );

  const claimLiqudityHook = useCallback(
    async (
      indux,
      smartAccountt,
      smartAccountClient,
      permissions,
      sessionKey
    ) => {
      const callArgsbefore = [
        {
          to: CLAIMING_ADDRESS, // The target contract address
          data: encodeFunctionData({
            abi: ClaimAbi,
            functionName: "claimRequest",
            args: [indux], // Pass the contract parameters
          }),
        },
      ];

      let gasFee = await handleGasFeeWithPreparedCalls(
        smartAccountClient,
        smartAccountt,
        callArgsbefore
      );
      const callArgs = [
        {
          to: CLAIMING_ADDRESS, // The target contract address
          data: encodeFunctionData({
            abi: ClaimAbi,
            functionName: "claimRequest",
            args: [indux], // Pass the contract parameters
          }),
        },
        {
          to: USDT_CONTRACT_ADDRESS,
          data: sendGasFeeAsUsdt(gasFee),
        },
      ];

      try {
        const preparedCalls = await smartAccountClient.prepareCalls({
          calls: callArgs,
          from: smartAccountt,
          capabilities: {
            permissions,
          },
        });
        const signedCalls = await signPreparedCalls(sessionKey, preparedCalls);
        const { preparedCallIds } = await smartAccountClient.sendPreparedCalls({
          ...signedCalls,
          capabilities: {
            permissions,
          },
        });
        const status = await smartAccountClient.getCallsStatus(
          preparedCallIds[0]
        );
        console.log("Call status:", status);
        return status;
      } catch (e) {
        throw e;
      }
    },
    [web3, account]
  );

  const rewardBeteHook = useCallback(
    async (smartAccountt, smartAccountClient, permissions, sessionKey) => {
      const callArgsbefore = [
        {
          to: CRASH_GAME_CONTRACT, // The target contract address
          data: encodeFunctionData({
            abi: CrashGameABI,
            functionName: "claimRewards",
            args: [], // Pass the contract parameters
          }),
        },
      ];

      let gasFee = await handleGasFeeWithPreparedCalls(
        smartAccountClient,
        smartAccountt,
        callArgsbefore
      );

      const callArgs = [
        {
          to: CRASH_GAME_CONTRACT, // The target contract address
          data: encodeFunctionData({
            abi: CrashGameABI,
            functionName: "claimRewards",
            args: [], // Pass the contract parameters
          }),
        },
        {
          to: USDT_CONTRACT_ADDRESS,
          data: sendGasFeeAsUsdt(gasFee),
        },
      ];
      console.log(
        callArgs,
        smartAccountt,
        "approveAmount, smartAccountt",
        placeBet
      );

      try {
        const preparedCalls = await smartAccountClient.prepareCalls({
          calls: callArgs,
          from: smartAccountt,
          capabilities: {
            permissions,
          },
        });
        const signedCalls = await signPreparedCalls(sessionKey, preparedCalls);
        const { preparedCallIds } = await smartAccountClient.sendPreparedCalls({
          ...signedCalls,
          capabilities: {
            permissions,
          },
        });
        const status = await smartAccountClient.getCallsStatus(
          preparedCallIds[0]
        );
        console.log("Call status:", status);

        return status;
      } catch (e) {
        throw e;
      }
    },
    [web3, account]
  );

  return {
    CashoutHook,
    PlaceBeteHook,
    AddLiqudityHood,
    WithDrawHook,
    PlaceBetLuckHook,
    claimLiqudityHook,
    rewardBeteHook,
  };
};

export default CashOut;
